// extracted by mini-css-extract-plugin
export default {"shimmer":"Radio_shimmer__RVkhq","dark_shimmer":"Radio_dark_shimmer__UG1r5","radio":"Radio_radio__0JgQ2"};